import React, { Fragment, useEffect } from "react";
import { useFieldArray, Control } from "react-hook-form";
import { TableRow, TableCell, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import ControlledNumberTextField from "components/Controller/ControlledNumberTextField";
import { IBillingNote } from "types/Sales/billing-note";

type Props = {
  control: Control<IBillingNote>;
  dtIndex: number;
  headers: any[];
  disabled: boolean;
  onEmpty: () => void;
  onRemoveIncome: (incomeId: string) => void;
};

const DeliveryTripIncomeRows = ({
  control,
  dtIndex,
  headers,
  disabled,
  onEmpty,
  onRemoveIncome,
}: Props) => {
  const { fields, remove } = useFieldArray({
    control,
    name: `delivery_trip_item_list.${dtIndex}.income_list`,
  });

  useEffect(() => {
    if (fields.length === 0) {
      onEmpty();
    }
  }, [fields.length, onEmpty]);

  return (
    <Fragment>
      {fields.map((income, incomeIndex) => (
        <TableRow
          key={income.id ?? income.income_unique_id}
          sx={{
            "& > td": {
              borderBottom: "none",
            },
          }}
        >
          {/* empty DT columns — one per DT-level header. 86d488a5h added
              ราคาน้ำมัน at index 6, so this is 7 cells now, not 6. These are
              positional: one too few and every income column below slides one
              place left under the wrong header. */}
          <TableCell />
          <TableCell />
          <TableCell />
          <TableCell />
          <TableCell />
          <TableCell />
          <TableCell />

          {/* item code */}
          <TableCell width={headers[7]?.width}>
            <Typography fontSize={14}>
              {income.income_item_unique_id}
            </Typography>
          </TableCell>

          {/* item name */}
          <TableCell width={headers[8]?.width}>
            <Typography fontSize={14}>{income.income_item_name}</Typography>
          </TableCell>

          {/* amount */}
          <TableCell
            align="right"
            width={headers[9]?.width}
            sx={{
              "& .MuiBox-root": {
                mr: disabled ? "1rem" : 0,
              },
            }}
          >
            <ControlledNumberTextField
              fullWidth
              control={control}
              name={`delivery_trip_item_list.${dtIndex}.income_list.${incomeIndex}.income_item_pre_vat_amount`}
              viewMode={disabled}
            />
          </TableCell>

          {/* action */}
          {!disabled && (
            <TableCell
              align="center"
              width={headers[10]?.width}
              sx={{ px: 1, py: 0.5 }}
            >
              <IconButton
                size="small"
                sx={{ color: "rgba(0,0,0,0.54)" }}
                onClick={() => {
                  remove(incomeIndex);
                  onRemoveIncome(income.income_unique_id);
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </TableCell>
          )}
        </TableRow>
      ))}
    </Fragment>
  );
};

export default React.memo(DeliveryTripIncomeRows);
